
(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name vcdms.vcfile.factory:FileHelper
   *
   * @description
   *
   */
  angular
    .module('vcdms.vcfile')
    .factory('FileHelper', FileHelper);
  
  
  FileHelper.$inject = ['File', '$uibModal', '$log', 'Rlog'];
  
  function FileHelper(File, $uibModal, $log, Rlog) {
    let FileHelperBase = {};
    
    FileHelperBase.editFile = editFile;
    FileHelperBase.addFile = addFile;
    
    
    function addFile(success, error) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><fileform file="vm.file" parentsave="vm.childsave(file)" oncancel="vm.cancel()"></filenew></div>',
        controllerAs: 'fileaCtrl',
        controller: ['file', function () {
          let vm = this;
          vm.file = {};
          
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          function childsave(file) {
            File.$create(file).$then(function (newfile) {
              vm.created = true;
              success(newfile);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ file-helper.addFile: ', err);
              Rlog.error('vcutils.file', 'file-helper.addFile', 'Creation of new File failed: ', {file: file});
              error(err);
              dialog.close();
            });
          }
          
          function cancel() {
            dialog.close();
          }
          
        }],
        resolve: {
          file: function () {
            return {};
          }
        },
        size: 'lg'
      });
    }
    
    
    function editFile(lfile) {
      let dialog = $uibModal.open({
        template: `
          <div class="modalspacer">
            <fileform file="fileeCtrl.file" parentsave="fileeCtrl.childsave(file)"
                      oncancel="fileeCtrl.cancel()"></fileform>
          </div>
        `,
        controllerAs: 'fileeCtrl',
        controller: ['file', function (sfile) {
          let vm = this;
          vm.file = sfile;
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          
          function childsave(file) {
            // vm.file = angular.copy(file);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in file) {
              if (file.hasOwnProperty(key)) {
                vm.file[key] = file[key];
              }
            }
            
            if (vm.file.$hasPendingActions()) {
              vm.file.$cancel();
              vm.file.$save();
              cancel();
            }
            else {
              vm.file.$save();
              dialog.close();
            }
          }
          
          
          function cancel() {
            dialog.close();
          }
          
          
        }],
        resolve: {
          file: function () {
            return lfile;
          }
        },
        size: 'lg'
      });
      return dialog;
    }
    
    return FileHelperBase;
  }
}());
